export interface DeliveryAsset {
  category?: string;
  album?: string;
  campaignTrackId: string;
  composerName?: string;
  description?: string;
  deliveryKeyCode?: string;
  isrc?: string;
  lyricistName?: string;
  trackDuration?: string;
  trackTitle: string;
  trackArtist?: string;
  types?: TrackTypes[];
  isReadyToPlay?: boolean;
  isPlaying?: boolean;
  isDownloading?: boolean;
  isDownloaded?: boolean;
  isDownloadError?: boolean;
  isAllowedToDownload?: boolean;
  isSelected?: boolean;
  assetKeyCode?: string;
  format?: string;
  name?: string;
  credits?: string;
  downloadUrl?: string;
  previewUrl?: string;
  usageRights?: string;
  cdn?: boolean;
  url?: string;
  type?: string;
  trackSequence?: number;
  asperaDwlUrl?: string;
  mediaType?: string;
  offlineDownloadStatus?: OfflineDownloadStatus;
  resetPlay?: boolean;
}

export interface TrackTypes {
  name?: string;
  asperaDwlUrl?: string;
  cdn?: boolean;
  size: number;
  trackKeyCode: string;
  deviceDownloadUrl?: string;
  type: string;
  url: string;
}

export interface FormatResponse {
  assetFormatId: number;
  assetFormatName: string;
  conversionSource: boolean;
  description: string;
  formatAccessType: string;
  hasWatermark: boolean;
}

export type OfflineDownloadStatus =
  | 'STARTED'
  | 'DOWNLOADING'
  | 'COMPLETED'
  | 'DELETED'
  | 'CANCELLED'
  | 'DAMAGED';
